import React from 'react';
import { Flex, Tag, TagLabel } from '@stockx/ui';
import { FooterProps } from '../types';

const TotalSoldFooter = ({ displayData }: FooterProps) => (
  <Flex mt="1">
    <Tag>
      <TagLabel>{displayData?.label}</TagLabel>
    </Tag>
  </Flex>
);

export default TotalSoldFooter;
